import React from "react";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { Typography, Theme } from "@material-ui/core";
import { Icon } from "../icons/Icon";
import { Link } from "../navigation/Link";
import { SearchField } from "../inputs/SearchField";
import transparentize from "../../utils/transparentize";

export interface ResultItem {
  label: string;
  url: string;
}

export type Props = {
  classes: any;
  className?: string;
  onSearch: (searchTerm: string) => void;
  icon: string;
  results?: ResultItem[];
  title: string;
};

type State = {
  search: string;
};

const styles = (theme: Theme) =>
  createStyles({
    header: {
      alignItems: "center",
      display: "flex",
      flexFlow: "row wrap",
      justifyContent: "space-between",
      paddingLeft: theme.spacing(2)
    },
    icon: {
      color: theme.palette.primary.light,
      marginRight: theme.spacing(1)
    },
    resultItem: {
      marginBottom: theme.spacing(1)
    },
    resultsContainer: {
      backgroundColor: transparentize(theme.palette.primary.light, 0.1),
      listStyle: "none",
      minHeight: "100px",
      padding: theme.spacing(2)
    },
    root: {
      width: "100%"
    },
    titleWrapper: {
      alignItems: "center",
      display: "flex",
      marginRight: theme.spacing(2)
    }
  });

class DetailSearchRelated extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      search: ""
    };
    this.onSubmitSearch = this.onSubmitSearch.bind(this);
    this.onUpdateSearch = this.onUpdateSearch.bind(this);
    this.onResetSearch = this.onResetSearch.bind(this);
  }

  onUpdateSearch(e: any) {
    e.persist();
    this.setState({
      search: e.target.value
    });
  }

  onSubmitSearch() {
    const search = this.state.search;
    this.props.onSearch(search);
  }

  onResetSearch() {
    const search = "";
    this.setState({
      search: search
    });
    this.props.onSearch(search);
  }

  render() {
    const { classes, icon, results, title } = this.props;
    const search = this.state.search;
    return (
      <div className={classes.root}>
        <div className={classes.header}>
          <div className={classes.titleWrapper}>
            <Icon className={classes.icon} name={icon} />
            <Typography variant="subtitle1">{title}</Typography>
          </div>
          <SearchField
            onSubmit={this.onSubmitSearch}
            onUpdate={this.onUpdateSearch}
            onReset={this.onResetSearch}
            value={search}
          />
        </div>
        {results && (
          <ul className={classes.resultsContainer}>
            {results.map(result => (
              <li className={classes.resultItem} key={result.label}>
                <Link id={result.label} label={result.label} url={result.url} />
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(DetailSearchRelated);
